import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { LIFECYCLE_ICONS } from './index.js';
/**
 * A-032's default icon renderer for `StatusBadge`/`Timeline`. Looks the concept up in the
 * lucide-react map; an unrecognised concept (a future reference-vocabulary value this
 * build of the client doesn't know about yet, API_CONTRACT.md §1.1) degrades to a neutral
 * dot rather than throwing or rendering nothing — the "icon or text, never color alone"
 * rule (§7.9) still holds even for a value shipped after this bundle was built.
 */
export function LifecycleIcon({ concept, size = 16, className }) {
    const Icon = LIFECYCLE_ICONS[concept];
    if (!Icon) {
        return (_jsx("span", { "aria-hidden": "true", className: className, children: "\u25CF" }));
    }
    return _jsx(Icon, { "aria-hidden": "true", width: size, height: size, strokeWidth: 2, className: className });
}
//# sourceMappingURL=LifecycleIcon.js.map